import React from "react";
import {
  Box,
  Container,
  Grid,
  Image,
  Heading,
  Text,
  Flex,
} from "@chakra-ui/react";
import { useState } from "react";
import stituted from "../../assets/about/apart/situted.png";

const newsData = [
  {
    id: 1,
    image: stituted,
    title:
      "Collaboration to Develop Coffee and Beverage Industry Expertise in Indonesia",
    date: "August 19, 2022",
    readTime: "4 Min",
  },
  {
    id: 2,
    image: stituted,
    title:
      "Collaboration to Develop Coffee and Beverage Industry Expertise in Indonesia",
    date: "August 19, 2022",
    readTime: "4 Min",
  },
  {
    id: 3,
    image: stituted,
    title: "New Coffee Trends Emerging in Indonesia",
    date: "September 5, 2022",
    readTime: "3 Min",
  },
];

const OtherNews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);


  return (
    <Box width={"100%"} bg={"#fcf7ef"}>
      <Container maxW="container.lg" py={10}>
        {/* Heading */}
        <Heading size="xl" mb={6} display={"flex"} justifyContent={"center"}>
          Other News
        </Heading>

        {/* Carousel Wrapper */}
        <Box position="relative" maxW="container.lg">
          <Grid
            templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
            gap={6}
            overflow="hidden"
            transition="transform 0.5s ease-in-out"
          >
            {newsData.slice(currentIndex, currentIndex + 2).map((item) => (
              <Box
                key={item.id}
                bg="white"
                p={4}
                borderRadius="md"
                boxShadow="md"
              >
                <Image
                  src={item.image}
                  alt="News Image"
                  borderRadius="md"
                  w="100%"
                  h="auto"
                />
                <Text mt={4} fontWeight="bold">
                  {item.title}
                </Text>
                <Text mt={2} fontSize="sm" color="gray.500">
                  {item.readTime} • {item.date}
                </Text>
              </Box>
            ))}
          </Grid>

          {/* Arrows Removed Here */}
        </Box>

        {/* Pagination Dots */}
        <Flex justify="center" mt={4}>
          {newsData.slice(0, newsData.length - 1).map((_, index) => (
            <Box
              key={index}
              w={3}
              h={3}
              mx={1}
              borderRadius="50%"
              bg={currentIndex === index ? "gray.700" : "gray.400"}
              cursor="pointer"
              transition="background 0.3s"
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </Flex>
      </Container>
    </Box>
  );
};

export default OtherNews;
